export default __webpack_public_path__ + "static/media/epa-logo.c531df88.svg";